import moize from 'moize';
import { Routing } from '@/constants';
export const getRouteIdentifierFromPath = moize((modelPath) => Object.keys(Routing.ROUTE_PATHS).find((key) => Routing.ROUTE_PATHS[key] === modelPath));
